import { forwardRef, useImperativeHandle, useMemo, useRef } from 'react'

import { t } from 'i18next'

import { TContent } from '@/config/types'

import { TSelectContentBlockControl } from './types'

export type TSingleLTPInfoBlockProps = {
  content: TContent
  className?: string
}

const defaultTemplate = '{name} for {price}'

export const SingleLTPInfoBlock = forwardRef<TSelectContentBlockControl, TSingleLTPInfoBlockProps>(
  function SelectContentBlock({ content, className }: TSingleLTPInfoBlockProps, ref) {
    const inputRef = useRef<HTMLDivElement>(null)
    const info = useMemo(() => {
      const template = t('ltpSelectPage.infoBlock.template') || defaultTemplate

      return template
        .replace('{name}', content.name)
        .replace('{price}', `$${content.price.toFixed(2)}`)
    }, [content.name, content.price])

    useImperativeHandle(
      ref,
      () => {
        return {
          scrollIntoView() {
            inputRef.current?.scrollIntoView()
          },
        }
      },
      []
    )
    let _containerClassName = 'single-ltp-block '
    if (className) {
      _containerClassName += className
    }
    return (
      <div className={_containerClassName} ref={inputRef}>
        {info}
      </div>
    )
  }
)
